import { render } from "./VcnpartyLink.vue?vue&type=template&id=2e57d138&scoped=true"
import script from "./VcnpartyLink.vue?vue&type=script&lang=js"
export * from "./VcnpartyLink.vue?vue&type=script&lang=js"

import "./VcnpartyLink.vue?vue&type=style&index=0&id=2e57d138&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e57d138"]])

export default __exports__